export enum DeviceCalibrationStatus {
    None = 0,
    BaselineRecorded = 1,
    NeedsMoreTime = 2,
    VerifiedAccurate = 3,
    DriftTooHigh = 4,
    EligibleForCalibration = 5,
    Calibrated = 6
}
